import { createSelector } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';
import { apiDietDiaryTypes } from './';

const selectSourceResult = apiDietDiaryTypes.endpoints.getSourceDietDiaryTypes.select();
export const selectSourceDietDiaryTypesAll = createSelector(selectSourceResult, (res) => {
  return res.data || [];
});
export const selectSourceDietDiaryTypesAllMap = createSelector(selectSourceDietDiaryTypesAll, (types) => {
  return keyBy(types, 'id');
});
